import { PermissionGuard } from '@/ui/components/permissionGuard/PermissionGuard';
import { AnchorButton, Button, Tooltip } from '@payaca/ambrosia';

import { IntegratedEmailsPermissions } from '@payaca/permissions/integrated-emails/integrated-emails.permissions';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';
import { Link, useParams } from 'react-router-dom';

export interface IProps {
  className?: string;
  setIsSendEmailModalOpen: (isOpen: boolean) => void;
}

const NavbarActions: FC<IProps> = (props) => {
  const { className, setIsSendEmailModalOpen } = props;
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <div className={'flex gap-x-2' + (className ? ' ' + className : '')}>
      <Tooltip className="inline-flex" tooltipContent="Create new project note">
        <AnchorButton
          as={Link}
          className="h-10"
          to={`/projects/${projectId}/activity/addNote`}
          variant="secondary"
          size={'sm'}
          aria-label="Create new project note"
        >
          <UntitledIcon name="pencil-line.3" className="h-5 w-5" />
        </AnchorButton>
      </Tooltip>
      <Tooltip
        className="inline-flex"
        tooltipContent="Create new project event"
      >
        <AnchorButton
          as={Link}
          to={`/projects/${projectId}/schedule/new`}
          variant="secondary"
          size={'sm'}
          aria-label="Create new project event"
        >
          <UntitledIcon name="calendar-plus-01.3" className="h-5 w-5" />
        </AnchorButton>
      </Tooltip>
      <PermissionGuard
        renderIfHasPermissions={[IntegratedEmailsPermissions.SEND_EMAIL]}
      >
        <Tooltip className="inline-flex" tooltipContent="Send email">
          <Button
            onClick={() => setIsSendEmailModalOpen(true)}
            variant="secondary"
            size={'sm'}
            aria-label="Send email"
          >
            <UntitledIcon name="mail-02.3" className="h-5 w-5" />
          </Button>
        </Tooltip>
      </PermissionGuard>
    </div>
  );
};

export default NavbarActions;
